export enum FileType {
  Audio = 'audio',
  Image = 'image',
  Unknown = 'unknown',
  Video = 'video',
}
